<template>
  <div>
    <div class="text-center">{{ countComputed }}</div>
  </div>
</template>
<script lang="ts" setup>
import { animate } from 'animejs'

const { targetValue = 0, text = '' } = defineProps<{
  targetValue?: number
  text?: string
}>()

onMounted(() => {
  animateCount(targetValue)
})

const count = ref<number>(0)
const countComputed = computed(() => {
  if (!text) {
    return count.value.toString()
  }
  return text.replace('{{number}}', count.value.toString())
})

const animateCount = (target: number) => {
  animate('count', {
    value: target,
    duration: 2000,
    easing: 'easeOutExpo',
    round: 1
  })
}

watch(
  () => targetValue,
  (newValue: number) => {
    count.value = newValue
    animateCount(newValue)
  },
  { immediate: true }
)
</script>
